// api/inventoryApi.js
import apiClient from "./axios"

// -------------------- INVENTORIES --------------------

// Get all inventories with optional filtering
export const getInventories = async (params = {}) => {
  const { data } = await apiClient.get("/inventories", { params })
  return data
}

// Get a specific inventory by ID
export const getInventory = async id => {
  const { data } = await apiClient.get(`/inventories/${id}`)
  return data
}

// Get an inventory by slug
export const getInventoryBySlug = async slug => {
  const { data } = await apiClient.get(`/inventories/slug/${slug}`)
  return data
}

// Create a new inventory
export const createInventory = async inventoryData => {
  const { data } = await apiClient.post("/inventories", inventoryData)
  return data
}

// Edit an existing inventory
export const editInventory = async ({ id, ...inventoryData }) => {
  const { data } = await apiClient.patch(`/inventories/${id}`, inventoryData)
  return data
}

// Soft delete an inventory
export const deleteInventory = async id => {
  const { data } = await apiClient.delete(`/inventories/${id}`)
  return data
}

// Permanently delete an inventory
export const forceDeleteInventory = async id => {
  const { data } = await apiClient.delete(`/inventories/${id}/force`)
  return data
}

// Get trashed (soft-deleted) inventories
export const getTrashedInventories = async (params = {}) => {
  const { data } = await apiClient.get("/inventories/trashed", { params })
  return data
}

// Restore a trashed inventory
export const restoreInventory = async id => {
  const { data } = await apiClient.post(`/inventories/${id}/restore`)
  return data
}

// Get all inventories without pagination
export const getAllInventories = async (params = {}) => {
  const { data } = await apiClient.get("/inventories", {
    params: { ...params, all: true },
  })
  return data
}

// Search inventories by term
export const searchInventories = async (searchTerm, params = {}) => {
  const { data } = await apiClient.get("/inventories", {
    params: { ...params, search: searchTerm },
  })
  return data
}
// Get all inventory companies

export const getInventoryCompanies = async (params = {}) => {
  const { data } = await apiClient.get("/vehicle-stock-inventory/companies", { params })
  return data
}

// -------------------- RELATED LISTS --------------------

// Get list of accessories
export const getAccessoriesList = async (params = {}) => {
  const { data } = await apiClient.get("/accessories", { params })
  return data
}

// Get list of senders (employees)
export const getSendersList = async (params = {}) => {
  const { data } = await apiClient.get("/employees", { params })
  return data
}

// Get list of receivers (vehicle importer staff)
export const getReceiversList = async (params = {}) => {
  const { data } = await apiClient.get("/vehicle-importer-staffs", { params })
  return data
}

// Get list of vehicles
export const getVehiclesList = async (params = {}) => {
  const { data } = await apiClient.get("/vehicle-stocks", { params })
  return data
}
